import { Checkbox } from '@delmonicos/shared-design-system-react/src/components/checkbox/checkbox';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MessageType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/enums/message-type.enum';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as css from './log-filters.module.scss';

interface ByMethodFilterComponentProps {
  selectedMethods: MessageType[];
  handleMethodsChange: (methods: MessageType[]) => void;
}

export const ByMethodFilterComponent = ({
  selectedMethods,
  handleMethodsChange,
}: ByMethodFilterComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [isSeeMore, setIsSeeMore] = useState(false);
  const allMethods = useMemo(
    () =>
      isSeeMore
        ? Object.values(MessageType)
        : Object.values(MessageType).slice(0, 3),
    [isSeeMore],
  );
  const allMethodsLength = useMemo(() => Object.values(MessageType).length, []);

  const handleSelectMethod = (isChecked: boolean, method: MessageType) => {
    if (isChecked) {
      handleMethodsChange([...selectedMethods, method]);
    } else {
      handleMethodsChange(selectedMethods.filter((m) => m !== method));
    }
  };

  const handleSelectAll = () => {
    if (selectedMethods.length === allMethodsLength) {
      handleMethodsChange([]);
    } else {
      handleMethodsChange(allMethods);
    }
  };

  return (
    <Stack gap={GapEnum.M} direction="column" className={css.byMethodContainer}>
      <IconText
        iconName="marker-pin-04"
        text={t('$.charge-point-details.maintenance.filter.method.title')}
      />

      <Checkbox
        id="all"
        label={t('$.charge-point-details.maintenance.filter.method.check-all')}
        onChange={handleSelectAll}
        checked={selectedMethods.length === allMethodsLength}
      />

      {allMethods.map((method: MessageType) => (
        <Checkbox
          key={method}
          id={method}
          label={method}
          onChange={(e) => handleSelectMethod(e.target.checked, method)}
          checked={selectedMethods.includes(method)}
        />
      ))}

      {!isSeeMore ? (
        <Link onClick={() => setIsSeeMore(true)}>
          {t('$.charge-point-details.maintenance.filter.method.see-more')}
          <Icon name="chevron-down" />
        </Link>
      ) : (
        <Link onClick={() => setIsSeeMore(false)}>
          {t('$.charge-point-details.maintenance.filter.method.see-less')}
          <Icon name="chevron-up" />
        </Link>
      )}
    </Stack>
  );
};
